<template>
  <div class="course-select" v-if="siftOthers && Object.keys(siftOthers).length > 0">
    <template>
      <select-row
        v-for="(value, key, index) in siftOthers"
        :key="index"
        :type="key"
        :label="siftNames[key]"
        :data="value"
        @input="controler"
      />
    </template>
    <fade-animation>
      <difficult-recommend
        v-if="showDiffcultRecommend"
        :data="difficultGuide"
      ></difficult-recommend>
      <grading-question v-if="showGradingQuestion" :data="difficultGuide" />
    </fade-animation>
    <difficult-degree
      v-if="showDifficultDegree"
      @updataDifficultId="updataDifficultyId"
    ></difficult-degree>
    <grading-result v-if="showGradingResult" @updataDifficultId="updataDifficultyId" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Enum from 'cg-enum'
import { courseEnum, siftParams } from '@/defines'
import DifficultRecommend from '@/components/DifficultRecommend'
import GradingQuestion from '@/components/GradingQuestion'
import DifficultDegree from '@/components/DifficultDegree'
import GradingResult from '@/components/GradingResult'
import FadeAnimation from '@/components/FadeAnimation'
import SelectRow from './SelectRow'
import filterSubject from '@/util/filterSubject'
export default {
  name: 'course-select',
  components: {
    SelectRow,
    DifficultRecommend,
    GradingQuestion,
    DifficultDegree,
    GradingResult,
    FadeAnimation
  },
  data() {
    return {
      courseEnum,
      courseType: null, // 默认同步课
      showDifficultGuide: true
    }
  },
  watch: {
    $route() {
      this.initData()
    }
  },
  created() {
    this.initData()
    this.$store.commit('SET_CURRENTGRADE', this.grade)
  },
  computed: {
    ...mapState({
      showDifficultDegree: state => state.CourseCenter.showDifficultDegree,
      showDiffcultRecommend: state => state.CourseCenter.showDiffcultRecommend,
      showGradingQuestion: state => state.showGradingQuestion,
      showGradingResult: state => state.showGradingResult,
      courseSift: state => state.CourseCenter.courseSift,
      siftOthers: state => state.CourseCenter.siftOthers,
      siftNames: state => state.CourseCenter.siftNames,
      difficultGuide: state => state.CourseCenter.difficultGuide,
      isAlreadyDegree: state => state.CourseCenter.isAlreadyDegree,
      subjectEnum: state => state.subjectEnum,
      currentGrade: state => state.currentGrade
    }),
    siftNames() {
      return this.courseSift.names
    },
    isLiveLongTerm() {
      return this.courseType === String(courseEnum.liveLongTerm)
    },
    isThreeLesson() {
      return this.courseType === String(courseEnum.threeLesson)
    }
  },
  methods: {
    initData() {
      // 子组件的选中状态保存在父组件的value中
      const {
        params: { grade, subject, courseType },
        query: {
          terms = '0',
          textbookContents = '0',
          versions = '0',
          studyPhases = '0',
          progresses = '0',
          difficulties = '0',
          times = '0',
          timeSlots = '0',
          knowledges = '0',
          labels = '0'
        }
      } = this.$route
      this.courseTypes = String(courseType)
      this.grade = String(grade)
      // this.subject = String(this.subjectEnum[subject])
      this.subjects = String(subject)
      this.difficulties = String(difficulties)
      this.terms = String(terms)
      this.textbookContents = String(textbookContents)
      this.versions = String(versions)
      this.studyPhases = String(studyPhases)
      this.progresses = String(progresses)
      this.times = String(times)
      this.timeSlots = String(timeSlots)
      this.knowledges = String(knowledges)
      this.labels = String(labels)
    },
    notEmptyCheck(obj) {
      if (obj) {
        return Object.keys(obj).length !== 0
      }
      return false
    },
    updataDifficultyId(val, event) {
      const dataMap = {}
      const difficulties = this.courseSift.difficulties
      for (let i = 0; i < difficulties.length; i++) {
        const item = difficulties[i]
        dataMap[item.id] = item
      }
      const notEmpty = this.notEmptyCheck(dataMap)
      if (notEmpty && !dataMap.hasOwnProperty(val)) {
        this.controler({ id: '0', type: 'difficultyId', index: 1 }, event)
        return
      }
      this.controler({ id: val, type: 'difficultyId' }, event)
    },
    controler({ id, type, index }, event) {
      if (type === 'grade') {
        this.$store.commit('SET_CURRENTGRADE', id)
      }
      this[type] = id // 更新当前click项的value
      this.updataRoute({ id, type, index, event })
    },
    updataRoute({ id, type, index, event }) {
      const routeInfo = this.routeInfo(id, type)
      if (type === 'subjects') {
        routeInfo.query.switch_grade = this.currentGrade
        routeInfo.query.switch_subject = filterSubject(id, this.subjectEnum)
      }
      // console.log('====routeInfo====', routeInfo)
      const isAlreadyDegree = this.isAlreadyDegree
      this.xesLog('click', { type, index, routeInfo, event, isAlreadyDegree })
      this.$router.push(routeInfo)
    },
    routeInfo(id, type) {
      const currentQuery = {}
      const { params, query } = this.$route
      currentQuery[type] = id
      if (type === 'courseTypes' && Number(id) === -25) {
        this.subjects = -925
      }
      return {
        name: 'course-center',
        params: {
          ...params,
          courseType: this.courseTypes,
          subject: this.subjects,
          grade: this.grade
        },
        query: { ...query, ...currentQuery }
      }
    },
    queryStr(obj) {
      let arr = []
      for (let key in obj) {
        arr.push([key, obj[key]])
      }
      const query = encodeURIComponent(arr.map(item => item.join('=')).join('&'))
      return '?' + query
    },
    xesLog(eventName, { type, index, routeInfo, event }) {
      const { courseType, subject, grade } = routeInfo.params
      const queryStr = this.queryStr(routeInfo.query)
      const clickURL = this.computedURL(
        `/course-center/${courseType}/${grade}/${subject}${queryStr}`
      )
      const clickIdArr = Object.keys(siftParams)
      const clickIdTypes = new Enum(clickIdArr, 3)
      const clickId = clickIdTypes[type]
      const XESLog = new this.$XESLog({
        key: `xeslog-courseCenterSelected-${type}`,
        subjectid: Number(subject),
        gradeid: Number(grade),
        courseType: Number(courseType),
        query: this.$route.query,
        clickurl: clickURL,
        itemid: index,
        clickid: '1.2.' + clickId,
        degreesubject: this.isAlreadyDegree
        // ,
        // exp_tag: this.$store.state.expTag
      })
      XESLog.push({ eventname: eventName, target: event.target }, this.$route)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
.course-select {
  background-color: #fff;
  padding: 11px 0;
  font-size: 13px;
  margin-bottom: 24px;
}
</style>



// WEBPACK FOOTER //
// ./src/views/CourseCenter/components/CourseSelect.vue